import { MigrationFlowData } from './MigrationFlowData';
import { MigrationActions } from './actions';
import { ActionType } from '../actionType';

export const migrationReducer = (state: MigrationFlowData, action: MigrationActions): MigrationFlowData => {
  switch (action.type) {
    case ActionType.SubmitForm:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
